// Energy analysis
// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive/$energyGroupId/energy-analysis',
)({
  component: EnergyTreeNodeAnalysisPage,
  staticData: { crumb: 'energyxplorer:app_bar.energy_analysis_node' },
});
